// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290620/js/" + chunkId + "." + {"44":"03b83117","225":"4dec589d","481":"36514dd3","486":"076370b4","770":"99b61f46"}[chunkId] + ".0.5864793987915791.chunk.js";
};